import ApiService from '../../../../../services/ApiService'
import GeneralService from '../../../../../services/GeneralService'

export default {
  async created() {
    this.userType = JSON.parse(localStorage.getItem('institution')).userType
    this.institutionId = JSON.parse(localStorage.getItem('institution')).id
    this.mainType = JSON.parse(localStorage.getItem('user')).mainType
    this.updateTable()
    this.getStandardEquipment()
  },

  data: () => ({
    errorMessage: '',
    error: false,
    visible: false,
    loading: false,
    deleteLoading: false,
    standardEquipmentLoading: false,
    deleteDialog: false,
    deleteManyDialog: false,
    buttonDeleteVisible: false,
    institutionId: null,
    templateSelected: [],
    standardEquipmentId: null,
    standardEquipment: [],
    calibrationPatternTemplates: [],
    currentCalibrationPatternTemplate: {},
    totalItensOnPage: 0,
    userType: null,
    mainType: null,
    page: 1,
    totalPages: 1,
    pageSize: 10,
    sizes: [10, 30, 90, 180],
    totalItems: 0,
    filter: {
      page: 1,
      pageSize: 10,
      name: null,
      standardEquipmentId: null,
      institutionId: null,
    },
    calibrationPatternTemplateName: null,
    headers: [
      {
        text: 'Template',
        align: 'center',
        value: 'name',
      },
      {
        text: 'Ações',
        align: 'center',
        value: 'actions',
        sortable: false,
      },
    ],
    headerProps: {
      sortByText: 'Ordenar por',
    },
    apiService: new ApiService(),
    generalService: new GeneralService(),
  }),

  components: {},

  methods: {
    addCalibrationPatternTemplate() {
      sessionStorage.clear()
      this.$router.push('/newCalibrationPatternTemplate')
    },

    editCalibrationPatternTemplate(calibrationPatternTemplate) {
      this.currentCalibrationPatternTemplate = calibrationPatternTemplate
      this.$router.push(
        `/editCalibrationPatternTemplate/${this.currentCalibrationPatternTemplate.id}`
      )
    },

    deleteTemplate(calibrationPatternTemplate) {
      this.currentCalibrationPatternTemplate = calibrationPatternTemplate
      this.deleteDialog = true
    },

    filterTable() {
      this.page = 1
      this.filter.page = this.page
      this.filter.pageSize = this.pageSize
      this.filter.name = this.calibrationPatternTemplateName
      this.filter.standardEquipmentId = this.standardEquipmentId

      this.updateTable()
    },

    async updateTable() {
      this.loading = true
      this.filter.institutionId = this.institutionId

      await this.apiService
        .post('calibrationPatternTemplate/list', this.filter)
        .then((response) => {
          this.totalPages = response.content.pager.totalPages
          this.calibrationPatternTemplates = response.content.templates
          this.totalItems = response.content.pager.totalItems
          this.totalItensOnPage = response.content.templates.length
          this.loading = false
        })
    },

    async getStandardEquipment() {
      this.standardEquipmentLoading = true

      this.standardEquipment =
        await this.generalService.getStandardEquipmentsByInstitution(
          this.institutionId
        )

      this.standardEquipmentLoading = false
    },

    async removeTemplate() {
      this.deleteLoading = true

      await this.apiService
        .delete(
          'calibrationPatternTemplate/delete',
          this.currentCalibrationPatternTemplate
        )
        .then(() => {
          this.updateTable()
        })
        .catch((err) => {
          window.scrollTo(0, 0)
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.deleteLoading = false
      this.deleteDialog = false
    },

    async removeMany() {
      this.deleteLoading = true

      await this.apiService
        .delete('calibrationPatternTemplate/deleteMany', this.templateSelected)
        .then(() => {
          this.updateTable()
          this.templateSelected = []
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
      this.deleteLoading = false
      this.deleteManyDialog = false
    },

    reset() {
      this.filter = {
        page: 1,
        pageSize: this.pageSize,
        name: null,
        standardEquipmentId: null,
      }
      this.calibrationPatternTemplateName = null
      this.standardEquipmentId = null
      this.updateTable()
    },
  },

  watch: {
    pageSize() {
      this.filter.pageSize = this.pageSize
      this.filter.page = 1
      this.updateTable()
    },

    page() {
      this.filter.page = this.page
      this.updateTable()
    },

    templateSelected() {
      this.buttonDeleteVisible = this.templateSelected.length > 0
    },
  },
}
